<template>

</template>

<script>
    import e6Tree from "e6-tree";

    export default {
        name: "departmentManagement",

        components: {
            e6Tree
        },

        data() {
            return {
                operateLoading: false, // 操作遮罩
                operateLoadingText: "", // 操作遮罩提示文字

                treeLoading: true, // 部门树数据加载遮罩
                departmentTreeList: [], // 部门树列表
                currentDepartment: null, // 当前选中的部门节点
                higherDepartmentId: null // 当前选中的部门的上级部门id
            };
        },

        methods: {
            // 获取部门树
            initDepartmentTree() {
                try {
                    this.treeLoading = true;
                    // let res = await this.userApi.getDepartmentTree();
                    // 测试删除
                    let res = {};
                    res.result = [
                        {
                            children: [
                                {
                                    children: [
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    disabled: false,
                                                    id: -115581,
                                                    label:
                                                        "易流云产品组测试人员深圳三账号测试账号测试部门超长名称测试部门",
                                                    pid: -112037,
                                                    vehicleCount: 0
                                                }
                                            ],
                                            disabled: false,
                                            id: -112037,
                                            label: "CESHI123",
                                            pid: -58551,
                                            vehicleCount: 0
                                        },
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    disabled: false,
                                                    id: -111569,
                                                    label: "asdsadas",
                                                    pid: -107252,
                                                    vehicleCount: 0
                                                },
                                                {
                                                    children: [
                                                        {
                                                            children: [],
                                                            disabled: false,
                                                            id: -112031,
                                                            label: "啊实打实大",
                                                            pid: -109639,
                                                            vehicleCount: 0
                                                        }
                                                    ],
                                                    disabled: false,
                                                    id: -109639,
                                                    label: "部门A13",
                                                    pid: -107252,
                                                    vehicleCount: 0
                                                }
                                            ],
                                            disabled: false,
                                            id: -107252,
                                            label: "sxtceshi",
                                            pid: -58551,
                                            vehicleCount: 0
                                        }
                                    ],
                                    disabled: false,
                                    id: -58551,
                                    label: "0123 新版本测试",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [
                                        {
                                            children: [],
                                            disabled: false,
                                            id: -110165,
                                            label: "啊实打森",
                                            pid: -61405,
                                            vehicleCount: 0
                                        }
                                    ],
                                    disabled: false,
                                    id: -61405,
                                    label: "0422魔方测试",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -114331,
                                    label: "711",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -102275,
                                    label: "bzp",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -82297,
                                    label: "E6尖兵测试",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -58540,
                                    label: "NB设备测试",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -112971,
                                    label: "test233",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [
                                        {
                                            children: [],
                                            disabled: false,
                                            id: -115108,
                                            label: "河南冷链",
                                            pid: -114717,
                                            vehicleCount: 0
                                        },
                                        {
                                            children: [],
                                            disabled: false,
                                            id: -114720,
                                            label: "冷链北部北京",
                                            pid: -114717,
                                            vehicleCount: 0
                                        },
                                        {
                                            children: [],
                                            disabled: false,
                                            id: -114719,
                                            label: "冷链东部杭州",
                                            pid: -114717,
                                            vehicleCount: 0
                                        },
                                        {
                                            children: [],
                                            disabled: false,
                                            id: -114722,
                                            label: "冷链东部南京",
                                            pid: -114717,
                                            vehicleCount: 0
                                        },
                                        {
                                            children: [],
                                            disabled: false,
                                            id: -114723,
                                            label: "冷链南部广州",
                                            pid: -114717,
                                            vehicleCount: 0
                                        },
                                        {
                                            children: [],
                                            disabled: false,
                                            id: -114718,
                                            label: "冷链中部成都",
                                            pid: -114717,
                                            vehicleCount: 0
                                        }
                                    ],
                                    disabled: false,
                                    id: -114717,
                                    label: "WIFI温签",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -115197,
                                    label: "XDKJ",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -113337,
                                    label: "ZGL",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -111621,
                                    label: "安必快",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -108119,
                                    label: "奥昆WIFI温签测试",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -87480,
                                    label: "百果园尖兵测试",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -100151,
                                    label: "北斗卫通",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -112020,
                                    label: "菜鸟测试",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [],
                                    disabled: false,
                                    id: -98818,
                                    label: "仓库监控测试账号",
                                    pid: -3661,
                                    vehicleCount: 0
                                },
                                {
                                    children: [
                                        {
                                            children: [],
                                            disabled: false,
                                            id: -100103,
                                            label: "测试部门A",
                                            pid: -100102,
                                            vehicleCount: 0
                                        },
                                        {
                                            children: [],
                                            disabled: false,
                                            id: -100104,
                                            label: "测试部门B",
                                            pid: -100102,
                                            vehicleCount: 0
                                        }
                                    ],
                                    disabled: false,
                                    id: -100102,
                                    label: "测试部门1",
                                    pid: -3661,
                                    vehicleCount: 0
                                }
                            ]
                        }
                    ];

                    let tree = [];
                    if (res.result && Array.isArray(res.result)) {
                        tree = res.result;
                    }
                    this.departmentTreeList = tree;

                    // 如果存在已选中的部门，刷新树后默认选中该部门节点并移至可见区域
                    if (this.currentDepartment !== null) {
                        this.$nextTick(() => {
                            this.$refs.departmentTree.setNodeSelect(
                                this.currentDepartment,
                                true
                            ); // 选中
                            this.$refs.departmentTree.letEleInView(this.currentDepartment.id); // 移至可见区域
                        });
                    }
                } catch (err) {
                    console.log(err);
                } finally {
                    this.treeLoading = false;
                }
            },
        },

        created() {
            this.initDepartmentTree(); // 获取部门树
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../assets/styles/deparment.scss";

    .department-manage {
        height: 100%;
        .add-department-wrapper,
        .edit-department-wrapper {
            padding: 20px 30px 20px 15px;
            /deep/ .el-form-item__content {
                .higher-department-tree {
                    .sub-selected-val {
                        border: 1px solid #f56c6c;
                    }
                }
                .el-select {
                    width: 237px;
                }
            }
        }
    }
</style>
